exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".togs_of[data-v-7ee8c980]{margin:0;text-align:center;text-transform:capitalize}.community_chanel[data-v-7ee8c980]{text-transform:uppercase;text-align:center;margin:0}.community_chanel2[data-v-7ee8c980]{text-transform:capitalize;text-align:center;margin:0}.humtog_s[data-v-7ee8c980]{margin-bottom:20px;background-color:#f5f8fa}.comtt_c[data-v-7ee8c980]{border-left:none!important}.community_togs[data-v-7ee8c980]{padding-left:15px!important;list-style-type:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7ee8c980","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/sidebars/CommunitySideBar.vue
// module id = hBja
// module chunks = 0